import Cd4pe from './cd4pe';

export default Cd4pe;
